import { InitialEditorStateType } from 'lexical';
import { useEffect, useState } from 'react';

type Props = {
  editorState?: InitialEditorStateType;
};

export default function useIsEditorEmpty({ editorState }: Props) {
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    if (editorState) setIsEmpty(false);
  }, [editorState]);

  return [isEmpty, setIsEmpty] as const;
}
